module.exports = __webpack_public_path__ + "img/revocation.29209987.svg";